import { render } from "./OcDetalle.vue?vue&type=template&id=37605472&scoped=true"
import script from "./OcDetalle.vue?vue&type=script&lang=js"
export * from "./OcDetalle.vue?vue&type=script&lang=js"

import "./OcDetalle.vue?vue&type=style&index=0&id=37605472&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37605472"]])

export default __exports__